/**
 * 医生统计报表模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取分馆总表统计
export const branchSummaryStatistics = ( /* pageNum, pageSize,  */ params) => {
  return req.post(`/report/dept`, params); /* ?pageSize=${pageSize}&pageNum=${pageNum} */
}

// 获取分馆经营统计
export const BranchOperation = (pageNum, pageSize, params) => {
  return req.post(`/report/deptEarnings?pageSize=${pageSize}&pageNum=${pageNum}`, params);
}

// 获取员工配方统计
export const formulaStatistics = (pageNum, pageSize, params) => {
  return req.post(`/report/repice?pageSize=${pageSize}&pageNum=${pageNum}`, params);
}

// 获取员工收费统计
export const tollmanStatistics = (pageNum, pageSize, params) => {
  return req.post(`/report/tollCollector?pageSize=${pageSize}&pageNum=${pageNum}`, params);
}

// 获取拍单数据统计
export const takeOrdersStatistics = (pageNum, pageSize, params) => {
  return req.post(`/report/auction?pageSize=${pageSize}&pageNum=${pageNum}`, params);
}

// 获取挂号数据统计
export const registrationStatistics = (pageNum, pageSize, params) => {
  return req.post(`/report/orderRegister?pageSize=${pageSize}&pageNum=${pageNum}`, params);
}

// 获取收费明细统计——按产品
export const chargeDetails = (pageNum, pageSize, params) => {
  return req.post(`/report/chargeSchedule?pageSize=${pageSize}&pageNum=${pageNum}`, params);
}

// 获取收费明细统计——按员工
export const chargeDetails1 = (pageNum, pageSize, params) => {
  return req.post(`/report/chargeSchedulePerson?pageSize=${pageSize}&pageNum=${pageNum}`, params);
}

// 获取药品销售统计
export const drugSalesStatistics = (pageNum, pageSize, params) => {
  return req.post(`/report/personProduct?pageSize=${pageSize}&pageNum=${pageNum}`, params);
}

// 获取收费日报表统计
export const chargeDay = (pageNum, pageSize, params) => {
  return req.post(`/report/tollCollectorDay?pageSize=${pageSize}&pageNum=${pageNum}`, params);
}

// 获取随访明细统计
export const followUpDetailsStatistics = (pageNum, pageSize, params) => {
  return req.post(`/report/examDetail?pageSize=${pageSize}&pageNum=${pageNum}`, params);
}

// 获取随访人员统计
export const followUpPersonnelStatistics = (pageNum, pageSize, params) => {
  return req.post(`/report/examPerson?pageSize=${pageSize}&pageNum=${pageNum}`, params);
}

// 获取员工加工统计
export const processStatistics = (pageNum, pageSize, params) => {
  return req.post(`report/reportProcessing?pageSize=${pageSize}&pageNum=${pageNum}`, params);
}
// 报表统计管理
// 列表
export const allReportList = (pageNum, pageSize, params) => {
  return req.get(`/general/report/list?pageSize=${pageSize}&pageNum=${pageNum}`, params);
}
// 详情
export const reportGet = (pageNum, pageSize, params) => {
  return req.get(`/general/report/get?pageSize=${pageSize}&pageNum=${pageNum}`, params);
}
// 数据导出
export const reportExport = (params, config) => {
  return req.downloadGet(`/general/report/export`, params, config);
}
// 报表数据查询
export const reportDetail = (pageNum, pageSize, params) => {
  return req.get(`/general/report/detail?pageSize=${pageSize}&pageNum=${pageNum}`, params);
}
// 删除
export const reportDel = (params) => {
  return req.get(`/general/report/delete`, params);
}
// 修改报表
export const reportEdit = (pageNum, pageSize, params) => {
  return req.post(`/general/report/edit`, params);
}
// 新增
export const reportAdd = (params) => {
    return req.post(`/general/report/add`, params);
}

// "reportId": 0,
// "reportRemark": "string",
// "reportSql": "string",
// "reportTitle": "string"

// 查询单据统计
export const getOrderPayDocNum = (params) => {
  return req.get(`/report/getOrderPayDocNum`, params);
}
// 查询单据
export const queryOrderPayDoc = (params) => {
  return req.get(`/report/queryOrderPayDoc`, params);
}
// 单据导出
export const exportOrderPayDoc = (params, customConfig) => {
  return req.downloadGet(`/report/exportOrderPayDoc`, params, customConfig, 'application/vnd.ms-excel');
}
// 查询明细
export const queryOrderDetailDoc = (params) => {
  return req.get(`/report/queryOrderDetailDoc`, params);
}
// 查询明细统计
export const geOrderDetailNum = (params) => {
  return req.get(`/report/geOrderDetailNum`, params);
}
// 明细导出
export const exportOrderDetail = (params, customConfig) => {
  return req.downloadGet(`/report/exportOrderDetail`, params, customConfig, 'application/vnd.ms-excel');
}
// 查询欠费订单
export const queryArrearsOrder = (params) => {
  return req.get(`/report/queryArrearsOrder`, params);
}
// 查询挂号结算
export const queryRegSetl = (params) => {
  return req.get(`/report/queryRegSetl`, params);
}
// 查询挂号结算统计
export const getRegSetlNum = (params) => {
  return req.get(`/report/getRegSetlNum`, params);
}

// 查询收费日报
export const getChargeReport = (params) => {
  return req.post(`/payReport/day`, params);
}
// 导出收费日报
export const exportChargeReport = (params, customConfig) => {
  return req.downloadGet(`/payReport/dayExport`, params, customConfig, 'application/vnd.ms-excel');
}
// 查询收费员统计
export const getCashier = (params) => {
  return req.post(`/payReport/cashier`, params);
}
// 导出收费员统计
export const cashierExport = (params, customConfig) => {
  return req.downloadGet(`/payReport/cashierExport`, params, customConfig, 'application/vnd.ms-excel');
}
// 查询执行业绩
export const getExecuteIncome = (params) => {
  return req.post(`/payReport/executeIncome`, params);
}

// 查询执行业绩
export const getExecuteIncomeCount = (params) => {
  return req.post(`/payReport/executeIncomeCount`, params);
}
// 获取分析系统token
export const getReportToken = (params) => {
  return req.get(`/webservice/finereport/create/ssotoken`, params, '/xl');
}

// 导出挂号结算
export const exportRegSetl = (params, customConfig) => {
  return req.downloadGet(`/report/exportRegSetl`, params, customConfig, 'application/vnd.ms-excel');
}

// 导出执行业绩
export const executeIncomeExport = (params, customConfig) => {
  return req.downloadGet(`/payReport/executeIncomeExport`, params, customConfig, 'application/vnd.ms-excel');
}
// 导出开方统计
export const exportPrescribe = (params, customConfig) => {
  return req.downloadGet(`/report/exportPrescribe`, params, customConfig, 'application/vnd.ms-excel');
}

// 开方统计
export const prescribePage = (params) => {
  return req.get(`/report/prescribePage`, params);
}

// 配方业绩报表
export const getFormulaPerformance = (params) => {
  return req.get(`/dc/statistic/prescription/workload`, params);
}

// 导出配方业绩报表
export const exportFormulaPerformance = (params, customConfig) => {
  return req.downloadGet(`/dc/statistic/prescription/workload/export`, params, customConfig, 'application/vnd.ms-excel');
}

// 加工业绩报表
export const getProcessPerformance = (params) => {
  return req.get(`/dc/statistic/process/workload`, params);
}

// 导出加工业绩报表
export const exportProcessPerformance = (params, customConfig) => {
  return req.downloadGet(`/dc/statistic/process/workload/export`, params, customConfig, 'application/vnd.ms-excel');
}

// 打包业绩报表
export const getPackPerformance = (params) => {
  return req.get(`/dc/statistic/package/workload`, params);
}

// 导出打包业绩报表
export const exportPackPerformance = (params, customConfig) => {
  return req.downloadGet(`/dc/statistic/package/workload/export`, params, customConfig, 'application/vnd.ms-excel');
}

//查询推送失败订单列表
export const getPushList = (params) => {
  return req.get(`/order/push/list`, params);
}
//重推雨诺
export const rePush = (params) => {
  return req.post(`/order/push/re-push`, params);
}
//导出配方日志
export const exportFormulaLog = (params, customConfig) => {
  return req.downloadGet(`/dc/prescription/delivery/export`, params, customConfig, 'application/vnd.ms-excel');
}

//查询配方日志
export const getFormulaLog = (params) => {
  return req.get(`/dc/prescription/delivery/findAllDecoctionCenDetail`, params);
}

//查询接待人业绩
export const getSalesPerformanceReportPage = (params) => {
  return req.get(`/saleReport/getSalesPerformanceReportPage`, params);
}
//导出接待业绩
export const salesExport = (params, customConfig) => {
  return req.downloadGet(`/saleReport/salesExport`, params, customConfig, 'application/vnd.ms-excel');
}
//查询优惠券报表
export const getCouponData = (params) => {
  return req.get(`/report/couponPage`, params);
}
//导出优惠券报表
export const couponExport = (params, customConfig) => {
  return req.downloadGet(`/report/exportCouponReport`, params, customConfig, 'application/vnd.ms-excel');
}